module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types"}
// module id = 3
// module chunks = 0